module.exports = __webpack_public_path__ + "img/MapThumb_CampLagoon.35334852.webp";